import { Grid, Typography } from '@mui/material';
import { PqrTimesDataProps } from './props';
import { usePqrTimesData } from './hook';
import FieldText from '../../../../../components/general/fields/fieldText';

export const PqrTimesDate = ({ data }: PqrTimesDataProps) => {
    const { formik } = usePqrTimesData(data);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Fecha Estado
                </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Fecha Estado 1"
                    name="typeSacTime"
                    size="small"
                    disabled
                    value={'SAC'}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    name="typeClassificationSacTime"
                    size="small"
                    disabled
                    label="Certificación"
                    errors={formik.errors.typeClassificationSacTime}
                    value={formik.values.typeClassificationSacTime}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Número de Días"
                    name="sacTime"
                    size="small"
                    disabled
                    errors={formik.errors.sacTime}
                    value={formik.values.sacTime}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Fecha Estado 2"
                    name="typeFuragTime"
                    size="small"
                    disabled
                    value={'Normativa'}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Certificación"
                    name="typeClassificationFuragTime"
                    size="small"
                    disabled
                    errors={formik.errors.typeClassificationFuragTime}
                    value={formik.values.typeClassificationFuragTime}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Número de Días"
                    name="furagTime"
                    size="small"
                    disabled
                    errors={formik.errors.furagTime}
                    value={formik.values.furagTime}
                />
            </Grid>
        </Grid>
    );
};
